"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uppercase = void 0;
var _styledComponents = require("styled-components");
var uppercase = (0, _styledComponents.css)(["html:not(:lang(el-gr)):not(:lang(ja-jp)):not(:lang(ko-kr)):not(:lang(th-th)):not(:lang(tr-tr)):not(:lang(zh-tw)) &{text-transform:uppercase;}"]);
exports.uppercase = uppercase;